import { QueryObserverResult, useQuery } from '@tanstack/react-query';

import {
  API_QUERY_KEYS,
  GetManageTeamConsulteesResponse,
  getManageTeamConsultees,
  QueryDefaults,
} from 'api';

export const useManageTeamConsultees =
  (): QueryObserverResult<GetManageTeamConsulteesResponse> =>
    useQuery([API_QUERY_KEYS.getManageTeamConsultees], getManageTeamConsultees, QueryDefaults);
